/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { xBaseTheme } from "@eisinc/XDL/types";

import button from "@eisinc/XDL/PreStyle/button";
import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        buttonProps: {
            ...button.primary,
        },
        cssOverrides: {
            currentButton: css`
                &,
                span {
                    color: ${getColor("common.white")};
                    background: ${getColor("primary")} !important;
                    border-color: ${getColor("primary")} !important;
                    text-shadow: none;
                    font-weight: 600;
                }
            `,
            linkList: css`
                button {
                    min-height: 22px;
                    height: 22px;
                    padding: 0 8px;
                    text-shadow: none;
                    color: ${getColor("text.main")};
                    font-weight: 600;
                    width: auto;
                    min-width: 22px;
                    &,
                    &:hover,
                    &:focus {
                        background-color: ${getColor("common.white")};
                        border-color: ${getColor("common.white")};
                    }
                }

                ul li button[data-test-selector="paginationButtonNext"],
                ul li button[data-test-selector="paginationButtonLast"],
                ul li button[data-test-selector="paginationButtonPrevious"],
                ul li button[data-test-selector="paginationButtonFirst"] {
                    svg {
                        color: ${getColor("text.main")};
                    }

                    &,
                    &:hover {
                        padding: 0 4px;
                        border: 0;
                        background-color: ${getColor("common.white")};
                    }
                }
            `,
            perPageSelect: css`
                margin-right: 50px;

                @media only screen and (max-width: 1140px) {
                    margin-right: 25px;
                }
            `,
        },
        selectProps: {
            cssOverrides: {
                formField: css`
                    display: flex;
                    align-items: center;
                `,
                formInputWrapper: css`
                    width: 65px;
                `,
            },
            labelProps: {
                css: css`
                    width: auto;
                    padding-top: 0;
                    padding-right: 10px;
                    font-weight: normal;
                `,
            },
        },
    },
} as xBaseTheme["pagination"];
